import { Alert, Link } from '@mm/components';
import { activeFacebookPageSelector } from '@mm/state/selectors/facebookPageSelector';
import classNames from 'classnames';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import './DialogueHeaderWarningAlert.pcss';

type Props = {
  beforeLinkText?: string;
  afterLinkText?: string;
  linkClassname?: string;
  alertClassName?: string;
  alertIsVisible?: boolean;
  showLink?: boolean;
  showAfterLinkText?: boolean;
};

export const DialogueHeaderWarningAlert = (props: Props) => {
  const {
    alertClassName,
    linkClassname,
    beforeLinkText,
    afterLinkText,
    alertIsVisible,
    showLink = true,
    showAfterLinkText = true,
  } = props;
  const facebookPage = useSelector(activeFacebookPageSelector);
  const [alertVisible, setAlertVisible] = useState(
    alertIsVisible || !!facebookPage?.euLimitsAt,
  );
  const onCloseAlert = () => {
    setAlertVisible(false);
  };
  const alertStyleClassname = classNames('warning-alert', alertClassName);
  const linkStyleClassname = classNames('warning-link', linkClassname);
  return alertVisible ? (
    <Alert
      type="warning"
      className={alertStyleClassname}
      showHeader
      closeIconProps={{ onClick: onCloseAlert }}
    >
      {beforeLinkText || 'Dialogue Testing is not supported due to'}{' '}
      {showLink && (
        <Link
          className={linkStyleClassname}
          href="https://mobilemonkey.com/help/article/cg1qvuexfy-updated-messaging-policies-for-eu-pages-users"
          isBlank
        >
          EU policy changes.
        </Link>
      )}
      {showAfterLinkText
        ? afterLinkText || ' Use Q&A keywords as a workaround.'
        : null}
    </Alert>
  ) : null;
};
